import { makeAutoObservable, runInAction } from 'mobx';
import { ContentReportsProxy } from '../services/catalogServiceAPI/contentReportsProxy';

/**
 * Open content reports awaiting moderation — the badge on the menu item.
 * Shared so resolving a report on the page updates the badge at once, and so
 * the two mounted navbars (sider + mobile drawer) make one request, not two.
 */
class OpenReportsStore {
    count = 0;
    inFlight = null;
    stale = false;
    proxy = new ContentReportsProxy();

    constructor() {
        makeAutoObservable(this, { inFlight: false, stale: false, proxy: false, refresh: false });
    }

    refresh() {
        if (this.inFlight) {
            // A change landed mid-request (e.g. a report was just resolved): ask again once it returns.
            this.stale = true;
            return this.inFlight;
        }
        this.inFlight = this.proxy.openCount()
            .then(count => runInAction(() => { this.count = count; }))
            // A badge is not worth an error toast; the page itself reports load failures.
            .catch(() => {})
            .finally(() => {
                this.inFlight = null;
                if (this.stale) {
                    this.stale = false;
                    this.refresh();
                }
            });
        return this.inFlight;
    }
}

export const openReportsStore = new OpenReportsStore();
